import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		redirectTo: '**',
		pathMatch: 'full',
	},
	{
		path: 'user-management',
		loadComponent: () => import('./pages/user-management/user-management.component').then((m) => m.UserManagementComponent),
	},
	{
		path: 'roles',
		loadComponent: () => import('./pages/roles/roles.component').then((m) => m.RolesComponent),
	},
	{
		path: 'pwa',
		loadComponent: () => import('./pages/pwa/pwa.component').then((m) => m.PwaComponent),
	},
	{
		path: 'files',
		loadComponent: () => import('./pages/files/files.component').then((m) => m.FilesComponent),
	},
	{
		path: 'edit-company',
		loadComponent: () => import('./pages/company/edit-company.component').then((m) => m.EditCompanyComponent),
	},
	{
		path: '',
		redirectTo: 'pwa',
		pathMatch: 'full',
	},
	{
		path: '**',
		redirectTo: 'error/404',
	},
];
